import { ObstructionType } from '../blueprint-classes/obstructions/enums';

export type EmptyObstructionDefault = {
	type: ObstructionType,
	width: number,
	height: number,
	depth: number | { left: number, right: number }
	countertopOverhang: number
};

export const emptyObstructionDefaults: Record<string, EmptyObstructionDefault> = {
	wall: {
		type: ObstructionType.Standard,
		width: 84,
		height: 39.25,
		depth: 6,
		countertopOverhang: 10
	},
	railing: {
		type: ObstructionType.Standard,
		width: 60,
		height: 34.5,
		depth: 6,
		countertopOverhang: 2
	}
};

export enum EmptyObstructionDefaults {
	'wall' = 'wall',
	'railing' = 'railing'
}
